import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ToastHostComponent } from '@shared/ui/organisms/toast-host/toast-host.component';

/**
 * Root shell. Deliberadamente delgado: solo el router-outlet y los overlays globales.
 * El "chrome" autenticado (topbar + sidenav + breadcrumbs) vive en layout/MainLayoutComponent,
 * montado como componente padre de las rutas protegidas en app.routes.ts.
 *
 * Los hosts globales (toasts, banner de conexion/circuit-breaker, beacon SLO) se proveen
 * a nivel raiz por core/error y core/observability y se renderizan aca. El host de toasts
 * (pvp-toast) DEBE vivir aca y no en el shell autenticado: los productores de toasts
 * (httpErrorInterceptor y GlobalErrorHandler) estan registrados a nivel app y pueden
 * despachar en rutas publicas (/auth, /forbidden, 404), fuera del area autenticada.
 * Montado aca, la garantia dispatch->render vale para TODA ruta.
 */
@Component({
    selector: 'app-root',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, ToastHostComponent],
    template: `
    <router-outlet />

    <!-- Viewport único de toasts: cualquier feature que empuje al ToastBus se renderiza acá. -->
    <pvp-toast />
  `
})
export class AppComponent {}
